import { matchPath } from 'react-router-dom';

export const adminRoutes = {
  root: '/admin',
  products: '/admin/produkty',
  productNew: '/admin/produkty/novy',
  productDetail: '/admin/produkty/:productId',
  reservations: '/admin/rezervace',
  reservationDetail: '/admin/rezervace/:reservationId',
  calendar: '/admin/kalendar',
  settings: '/admin/nastaveni',
  fittings: '/admin/zkousky',
  fittingDetail: '/admin/zkousky/:fittingId',
  invoices: '/admin/faktury',
} as const;

export function buildAdminProductDetailPath(productId: string) {
  return `/admin/produkty/${encodeURIComponent(productId)}`;
}

export function buildAdminReservationDetailPath(reservationId: string) {
  return `/admin/rezervace/${encodeURIComponent(reservationId)}`;
}

export type AdminNavigationKey = 'overview' | 'products' | 'reservations' | 'calendar' | 'settings' | 'fittings' | 'invoices';

export const adminNavigationItems: ReadonlyArray<{ key: AdminNavigationKey; label: string; to: string }> = [
  { key: 'overview', label: 'Přehled', to: adminRoutes.root },
  { key: 'products', label: 'Produkty', to: adminRoutes.products },
  { key: 'fittings', label: 'Zkoušky', to: adminRoutes.fittings },
  { key: 'reservations', label: 'Rezervace', to: adminRoutes.reservations },
  { key: 'calendar', label: 'Kalendář', to: adminRoutes.calendar },
  { key: 'invoices', label: 'Faktury', to: adminRoutes.invoices },
  { key: 'settings', label: 'Nastavení', to: adminRoutes.settings },
];

export function resolveAdminNavigation(pathname: string): AdminNavigationKey | null {
  if (matchPath({ path: adminRoutes.root, end: true }, pathname)) return 'overview';
  if (matchPath({ path: '/admin/produkty/*', end: false }, pathname)) return 'products';
  if (matchPath({ path: '/admin/rezervace/*', end: false }, pathname)) return 'reservations';
  if (matchPath({ path: adminRoutes.calendar, end: true }, pathname)) return 'calendar';
  if (pathname === adminRoutes.invoices) return 'invoices';
  if (matchPath({ path: '/admin/zkousky/*', end: false }, pathname)) return 'fittings';
  if (pathname === adminRoutes.settings) return 'settings';
  return null;
}

export function resolveAdminPageTitle(pathname: string) {
  if (matchPath({ path: adminRoutes.productNew, end: true }, pathname)) return 'Nový produkt';
  if (matchPath({ path: adminRoutes.productDetail, end: true }, pathname)) return 'Upravit produkt';
  if (matchPath({ path: adminRoutes.products, end: true }, pathname)) return 'Produkty';
  if (matchPath({ path: adminRoutes.reservationDetail, end: true }, pathname)) return 'Detail rezervace';
  if (matchPath({ path: adminRoutes.reservations, end: true }, pathname)) return 'Rezervace';
  if (matchPath({ path: adminRoutes.calendar, end: true }, pathname)) return 'Kalendář';
  if (pathname === adminRoutes.invoices) return 'Faktury';
  if (matchPath({ path: adminRoutes.fittingDetail, end: true }, pathname)) return 'Detail zkoušky';
  if (pathname === adminRoutes.fittings) return 'Zkoušky';
  if (pathname === adminRoutes.settings) return 'Nastavení';
  return 'Přehled';
}